<template>
    <section class="hero">

        <div class="hero__container">

            <div class="hero__content animated fadeInDown delayied">

                <h1>

                    <small>{{ subtitle }}</small>

                    <span class="uppercase">{{ title }}</span>

                </h1>

                <slot name="default"></slot>

                <a :href="href" class="btn">
                    {{ buttonLabel }}
                </a>

            </div>

            <div class="hero__image animated fadeInDown delayied-x2">
                <img :src="heroImg" :alt="title">
            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: "BrHero",
    props: {
        href: {
            type: String,
            default: "#"
        },
        title: {
            type: String,
            default: "Bridgerocks"
        },
        subtitle: {
            type: String,
            default: "Strategic Advisory"
        },
        heroImg: {
            type: String,
            default: "bridgerock_world_9.webp"
        },
        buttonLabel: {
            type: String,
            default: "Our services"
        }
    }
};
</script>

<style lang="scss">
.view-content {
    &>.hero {
        padding-top: 0px;
        padding-bottom: 90px;

        h1 {
            small {
                float: left;
                clear: both;
                font-size: 1.5rem;
                font-weight: 400;
                text-transform: uppercase;
                color: var(--primary);
            }

            span {
                float: left;
                clear: both;
            }
        }
    }
}
</style>